import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about'
import features from '@/components/features'
import portfolioTwo from '@/components/portfolio-grid-2-column'
import portfolioThree from '@/components/portfolio-grid-3-column'
import portfolioFour from '@/components/portfolio-grid-4-column'
import blog from '@/components/blog'
import blogdetail from '@/components/blog-detail'
import faq from '@/components/faq'
import pagenotfound from '@/components/404'
import contact from '@/components/contact'
import login from '@/components/login'
import register from '@/components/register'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/about',
            name: 'about',
            component: about
        },  
        {
            path: '/features',
            name: 'features',
            component: features
        },
        {
            path: '/portfolioTwo',
            name: 'portfolioTwo',
            component: portfolioTwo
        },
        {
            path: '/portfolioThree',
            name: 'portfolioThree',
            component: portfolioThree
        },
        {
            path: '/portfolioFour',
            name: 'portfolioFour',
            component: portfolioFour
        },
        {
            path: '/blog',
            name: 'blog',
            component: blog
        },
        {
            path: '/blogdetail',
            name: 'blogdetail',
            component: blogdetail
        },
        {
            path: '/faq',
            name: 'faq',
            component: faq
        },
        {
            path: '/404',
            name: 'pagenotfound',
            component: pagenotfound
        }, {
            path: '/contact',
            name: 'contact',
            component: contact
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/register',
            name: 'register',
            component: register
        },
    ]
})
